// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar {
  position: fixed;
  top: 60px; /* Adjust based on your navbar height */
  left: 0;
  height: calc(100vh - 60px);
  width: 250px;
  background-color: var(--bg-color-navbar);
  padding: 2rem 0;
  z-index: 500; /* Lower than navbar to ensure navbar shadow appears on top */
  overflow-y: auto;
  transition: width 0.3s ease;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
}

.sidebar-collapsed {
  width: 85px;
}

.sidebar-toggle {
  position: absolute;
  right: -15px;
  top: 15px ;
  transform: translate(-50%, -50%);
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: var(--link-color);
  background-color: unset;
  border-radius: 6px;
  transition: all 0.3s ease;
  z-index: 10;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.2s;
}

.sidebar:hover .sidebar-toggle,
.sidebar:focus-within .sidebar-toggle {
  opacity: 1;
  pointer-events: auto;
}

.sidebar-toggle:hover {
  background-color: var(--bs-primary);
  color: var(--bs-white);
}

.toggle-arrow {
  transition: transform 0.3s ease;
}

.toggle-arrow.rotated {
  transform: rotate(180deg);
}

.sidebar .nav-link {
  color: var(--link-color) !important;
  padding: 0.75rem 1.5rem;
  border-radius: 0;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  font-weight: 500;
  text-decoration: none;
  justify-content: flex-start;
  overflow: hidden;
  white-space: nowrap;
}

.sidebar-collapsed .nav-link {
  padding: 0.75rem;
  justify-content: center;
}

.sidebar-collapsed .nav-link span {
  display: none;
}

.sidebar .nav-link:hover {
  background-color: var(--bg-color-navbar-hover);
  color: var(--link-hover-color) !important;
}

.sidebar .nav-link.active {
  background-color: var(--bs-primary);
  color: var(--bs-white) !important;
}

/* Tooltip for collapsed items */
.sidebar-collapsed .nav-link {
  position: relative;
}

.sidebar-collapsed .nav-link::after {
  content: attr(title);
  position: absolute;
  left: 100%;
  top: 50%;
  transform: translateY(-50%);
  background-color: var(--bs-dark);
  color: var(--bs-white);
  padding: 0.5rem 0.75rem;
  border-radius: 6px;
  white-space: nowrap;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
  margin-left: 10px;
  font-size: 0.875rem;
  z-index: 1000;
  box-shadow: 0 2px 8px rgba(0,0,0,0.15);
}

.sidebar-collapsed .nav-link:hover::after {
  opacity: 1;
  visibility: visible;
}

/* Dark theme support */
[data-bs-theme="dark"] .sidebar {
  background-color: var(--bg-color-navbar);
  border-right-color: var(--bs-gray-700);
}

[data-bs-theme="dark"] .sidebar .nav-link {
  color: var(--link-color) !important;
}

[data-bs-theme="dark"] .sidebar .nav-link:hover {
  background-color: var(--bg-color-navbar-hover);
  color: var(--link-hover-color) !important;
}

[data-bs-theme="dark"] .sidebar-toggle {
  background-color: unset;
  color: var(--link-color);
}

[data-bs-theme="dark"] .sidebar-collapsed .nav-link::after {
  background-color: var(--bs-gray-800);
  color: var(--bs-white);
}

/* Responsive design */
@media (max-width: 768px) {
  .sidebar {
    display: none; /* Hide sidebar on mobile, use navbar collapse instead */
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Sidebar.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,SAAS,EAAE,uCAAuC;EAClD,OAAO;EACP,0BAA0B;EAC1B,YAAY;EACZ,wCAAwC;EACxC,eAAe;EACf,YAAY,EAAE,6DAA6D;EAC3E,gBAAgB;EAChB,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,wBAAwB;EACxB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,UAAU;EACV,oBAAoB;EACpB,wBAAwB;AAC1B;;AAEA;;EAEE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,mCAAmC;EACnC,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,uBAAuB;EACvB,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,2BAA2B;EAC3B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,8CAA8C;EAC9C,yCAAyC;AAC3C;;AAEA;EACE,mCAAmC;EACnC,iCAAiC;AACnC;;AAEA,gCAAgC;AAChC;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,gCAAgC;EAChC,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;EACV,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,sCAAsC;AACxC;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,wCAAwC;EACxC,sCAAsC;AACxC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,8CAA8C;EAC9C,yCAAyC;AAC3C;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa,EAAE,wDAAwD;EACzE;AACF","sourcesContent":[".sidebar {\n  position: fixed;\n  top: 60px; /* Adjust based on your navbar height */\n  left: 0;\n  height: calc(100vh - 60px);\n  width: 250px;\n  background-color: var(--bg-color-navbar);\n  padding: 2rem 0;\n  z-index: 500; /* Lower than navbar to ensure navbar shadow appears on top */\n  overflow-y: auto;\n  transition: width 0.3s ease;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  justify-content: flex-start;\n}\n\n.sidebar-collapsed {\n  width: 85px;\n}\n\n.sidebar-toggle {\n  position: absolute;\n  right: -15px;\n  top: 15px ;\n  transform: translate(-50%, -50%);\n  width: 30px;\n  height: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: var(--link-color);\n  background-color: unset;\n  border-radius: 6px;\n  transition: all 0.3s ease;\n  z-index: 10;\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 0.2s;\n}\n\n.sidebar:hover .sidebar-toggle,\n.sidebar:focus-within .sidebar-toggle {\n  opacity: 1;\n  pointer-events: auto;\n}\n\n.sidebar-toggle:hover {\n  background-color: var(--bs-primary);\n  color: var(--bs-white);\n}\n\n.toggle-arrow {\n  transition: transform 0.3s ease;\n}\n\n.toggle-arrow.rotated {\n  transform: rotate(180deg);\n}\n\n.sidebar .nav-link {\n  color: var(--link-color) !important;\n  padding: 0.75rem 1.5rem;\n  border-radius: 0;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  font-weight: 500;\n  text-decoration: none;\n  justify-content: flex-start;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n.sidebar-collapsed .nav-link {\n  padding: 0.75rem;\n  justify-content: center;\n}\n\n.sidebar-collapsed .nav-link span {\n  display: none;\n}\n\n.sidebar .nav-link:hover {\n  background-color: var(--bg-color-navbar-hover);\n  color: var(--link-hover-color) !important;\n}\n\n.sidebar .nav-link.active {\n  background-color: var(--bs-primary);\n  color: var(--bs-white) !important;\n}\n\n/* Tooltip for collapsed items */\n.sidebar-collapsed .nav-link {\n  position: relative;\n}\n\n.sidebar-collapsed .nav-link::after {\n  content: attr(title);\n  position: absolute;\n  left: 100%;\n  top: 50%;\n  transform: translateY(-50%);\n  background-color: var(--bs-dark);\n  color: var(--bs-white);\n  padding: 0.5rem 0.75rem;\n  border-radius: 6px;\n  white-space: nowrap;\n  opacity: 0;\n  visibility: hidden;\n  transition: all 0.3s ease;\n  margin-left: 10px;\n  font-size: 0.875rem;\n  z-index: 1000;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.15);\n}\n\n.sidebar-collapsed .nav-link:hover::after {\n  opacity: 1;\n  visibility: visible;\n}\n\n/* Dark theme support */\n[data-bs-theme=\"dark\"] .sidebar {\n  background-color: var(--bg-color-navbar);\n  border-right-color: var(--bs-gray-700);\n}\n\n[data-bs-theme=\"dark\"] .sidebar .nav-link {\n  color: var(--link-color) !important;\n}\n\n[data-bs-theme=\"dark\"] .sidebar .nav-link:hover {\n  background-color: var(--bg-color-navbar-hover);\n  color: var(--link-hover-color) !important;\n}\n\n[data-bs-theme=\"dark\"] .sidebar-toggle {\n  background-color: unset;\n  color: var(--link-color);\n}\n\n[data-bs-theme=\"dark\"] .sidebar-collapsed .nav-link::after {\n  background-color: var(--bs-gray-800);\n  color: var(--bs-white);\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n  .sidebar {\n    display: none; /* Hide sidebar on mobile, use navbar collapse instead */\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
